<template>
  <div class="container custom-side-filter">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <van-cell
            title="课程"
            is-link
            :value-class=" params.curriculumName ? 'selected':''"
            :value="params.curriculumName || '请选择'"
            @click="toChoiceCourse"
          />
          <div class="three-a-row">
            <div class="nav-title">试听状态</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of stuStaList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.statusList && params.statusList.includes(item.val),
                    all:
                      (!params.statusList || !params.statusList.length) &&
                      item.val === '',
                  }"
                  @click="triggerStuSta(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>

          <div class="three-a-row">
            <div class="nav-title">学员状态</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of studentStatusList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.studentStatusList && params.studentStatusList.includes(item.val),
                    all:
                      (!params.studentStatusList || !params.studentStatusList.length) &&
                      item.val === '',
                  }"
                  @click="triggerStudentStaus(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>

          <div class="three-a-row">
            <div class="nav-title">试听时间</div>
            <div class="date-box">
              <input-date-range :start="params.startDate" :end="params.endDate" @change="chooseCalendar"></input-date-range>
            </div>
          </div>

          <van-cell
            title="跟进人"
            is-link
            :value="params.followTeacherName || ''"
            :value-class="params.followTeacherName ? 'selected':''"
            @click="chooseFollowTeacher"
          />
        </div>

        <van-row class="footer" gutter="12">
          <van-col span="12">
            <van-button block square round @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm">
              确定
            </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
import InputDateRange from '@x3/vue/comp/input-date-range.vue';

let defaultParams = {
  // 校区ID集合
  campusIds: [],
  campusList: [],
  curriculumId: '',
  curriculumName: '',
  statusList: [],
  studentStatusList: [],
  endDate: '',
  startDate: '',
  followTeacherId: '',
  followTeacherName: ''
};

export default {
  name: "auditionFiltrate",
  inject: ['studentsStatusDict'],
  data() {
    return {
      visible: false,
      params: JSON.parse(JSON.stringify(defaultParams)),
      stuStaList: [
        {name: '待试听', id: 0, val: 0},
        {name: '已试听', id: 1, val: 1},
        {name: '已取消', id: 3, val: 3},
      ],
    };
  },
  computed: {
    studentStatusList() {
      return Object.keys(this.studentsStatusDict).filter(key=>+key <= 7).map(key=> ({
        id: +key,
        name: this.studentsStatusDict[key],
        val: +key,
      }));      
    },
  },
  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },
    // 选择课程
    async toChoiceCourse() {
      if (this.priceInputDisabled) {
        return false;
      }
      let res = await app.x3.side.xsCourse({
        id: this.params.curriculumId,
      });
      this.params.curriculumId = res ? res.id : "";
      this.params.curriculumName = res ? res.curriculumName : "";
      // this.clearPriceChoice();
    },
    // 学业状态处理
    triggerStuSta(item) {
      let i = this.params.statusList.indexOf(item.val);
      if (i === -1) {
        this.params.statusList.push(item.val);
      } else {
        this.params.statusList.splice(i, 1);
      }
    },
    triggerStudentStaus(item) {
      let i = this.params.studentStatusList.indexOf(item.val);
      if (i === -1) {
        this.params.studentStatusList.push(item.val);
      } else {
        this.params.studentStatusList.splice(i, 1);
      }
    },
    // 选择跟进人
    async chooseFollowTeacher() {
      let res = await app.x3.side.xsTeacher({
        id: this.params.followTeacherId
      });
      this.params.followTeacherId = res ? res.id : '';
      this.params.followTeacherName = res ? res.name : '';
    },
    // 显示日期选择框
    chooseCalendar(ret) {
      this.params.startDate = ret.startDate
      this.params.endDate = ret.endDate
    },
    // 重置
    reset() {
      this.params = JSON.parse(JSON.stringify(defaultParams));
    },
    doneAnima() {
      this.$router.back();
      return new Promise((rsv) => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      let params = {
        ...this.params,
        startDate: app.tool.date.formatDatetime(this.params.startDate, 'yyyy-MM-dd'), 
        endDate: app.tool.date.formatDatetime(this.params.endDate, 'yyyy-MM-dd'), 
      }
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params: params,
          })
        )
      );
    },
  },
  created() {
    this.prevInit();
  },
  beforeDestroy() {},
  watch: {
    "$vxRoute.vx_action": function (nv, ov) {
      // console.log(nv);
      if (nv == "vx-out") {
        this.visible = false;
      }
    },
  },
  components: {
    InputDateRange
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;
      .price-item-title{
        flex: unset;
        width: calc(var(--w) * 60);
      }
    }
  }
}
</style>